import { render } from "./TheProfessionalExpedientFileMedicalData.vue?vue&type=template&id=4c2c49c7&ts=true"
import script from "./TheProfessionalExpedientFileMedicalData.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalExpedientFileMedicalData.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__